var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    _vm._g(
      _vm._b(
        {
          staticClass: "jade-action-button",
          class: _vm.computedClassName,
          attrs: { type: "button", "aria-label": "jade-action-button" },
        },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.icon
        ? _c(
            "div",
            { staticClass: "jade-action-button__icon-wrapper" },
            [
              _c("jade-icon", {
                attrs: {
                  color: "current-color",
                  size: "medium",
                  use: _vm.icon,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$slots.default,
              expression: "$slots.default",
            },
          ],
          staticClass: "jade-action-button__label",
        },
        [
          _c(
            "jade-text",
            {
              attrs: {
                color: "current-color",
                variant: "text-medium",
                weight: "semibold",
              },
            },
            [_vm._t("default")],
            2
          ),
        ],
        1
      ),
      _vm.shouldDisplayCounter
        ? _c(
            "div",
            {
              staticClass: "jade-action-button__counter",
              class: { "is-active": _vm.active },
            },
            [
              _c("jade-badge", { attrs: { voice: "brand", variant: "text" } }, [
                _vm._v(" " + _vm._s(_vm.counter) + " "),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.dropdownIndicator
        ? _c(
            "div",
            { staticClass: "jade-action-button__icon-wrapper" },
            [
              _c("jade-icon", {
                attrs: {
                  size: "medium",
                  use: "chevron-down",
                  color: "current-color",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }